/**
 * @generated SignedSource<<cad15fe816c266bf59b45b47b6c118aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type taskExecutionListCombineCheckTaskExecutions$data = ReadonlyArray<{
  readonly checkValue: TaskSentiment | null;
  readonly " $fragmentType": "taskExecutionListCombineCheckTaskExecutions";
}>;
export type taskExecutionListCombineCheckTaskExecutions$key = ReadonlyArray<{
  readonly " $data"?: taskExecutionListCombineCheckTaskExecutions$data;
  readonly " $fragmentSpreads": FragmentRefs<"taskExecutionListCombineCheckTaskExecutions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "taskExecutionListCombineCheckTaskExecutions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionCheck",
  "abstractKey": null
};

(node as any).hash = "808635625436add481f576921dc12931";

export default node;
